import { KEY_COTIZACION_CREADA_DESDE_CONTRATANTE } from '../../../models/cotizador-contratante/crear cotizacion/cotizacion-creada-contratante-guardada.model';

export interface CotizacionGuardadaDesdeContratante {
  status?: boolean;
  data?: { idContratante?: number; idCotizacion?: number; };
  tipoDocumento?: string;
  numeroDocumento?: string;
}

export function getCotizacionGuardadaDesdeContratante(): CotizacionGuardadaDesdeContratante | null {
  try {
    const raw = localStorage.getItem(KEY_COTIZACION_CREADA_DESDE_CONTRATANTE);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function getIdContratanteFromLocal(): number | null {
  const saved = getCotizacionGuardadaDesdeContratante();
  const id = saved?.data?.idContratante;
  return Number.isFinite(Number(id)) ? Number(id) : null;
}

export function getIdCotizacionFromLocal(): number | null {
  const saved = getCotizacionGuardadaDesdeContratante();
  const id = saved?.data?.idCotizacion;
  return Number.isFinite(Number(id)) ? Number(id) : null;
}

export function getEsUsuarioFromLocalContratante(): boolean | null {
  try {
    const raw = localStorage.getItem('datosRQ002_Contratante');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const val = parsed?.esUsuario;
    if (typeof val === 'boolean') return val;
    if (typeof val === 'string') {
      const t = val.trim().toLowerCase();
      if (t === 'true') return true;
      if (t === 'false') return false;
    }
    return null;
  } catch {
    return null;
  }
}
